import { useState } from 'react';
import { systemInfoQuery } from '../services';
import { getPathNameByRow } from '../system';
export const oaQuery = 'oApproval=true';
/**
 * 判断当前页面是否是oa模式
 * @returns
 */
export const getCurrentOaMode = () => {
    return (window.location.search.indexOf(`?${oaQuery}`) > -1 ||
        window.location.search.indexOf(`&${oaQuery}`) > -1);
};
function getLocal(key) {
    const jsonData = window.localStorage.getItem(key);
    return jsonData ? JSON.parse(jsonData) : {};
}
export const useJumpPageRouteGet = (headers) => {
    const [sysPasePathMap, setSysBasePathMap] = useState(getLocal('sysBasePaths'));
    // 根据系统id或者系统code获取基本系统信息
    const getSystemInfo = async ({ sysId, sysCode, }) => {
        if (!sysId && !sysCode) {
            return undefined;
        }
        if (sysId) {
            if (sysPasePathMap[sysId]?.systemId) {
                return sysPasePathMap[sysId];
            }
        }
        else if (sysCode) {
            if (sysPasePathMap[sysCode]?.systemId) {
                return sysPasePathMap[sysCode];
            }
        }
        const res = await systemInfoQuery({ id: sysId, code: sysCode }, {
            'function-code': 'HOME-SYSTEM-GET',
        });
        let pcPath = res.data?.pcPath?.replace(':id', res.data?.id);
        if (!pcPath?.startsWith('/')) {
            pcPath = '/' + pcPath;
        }
        if (pcPath?.endsWith('/')) {
            pcPath = pcPath.substring(0, pcPath.length - 1);
        }
        const recordInfo = {
            code: res.data?.code,
            systemId: res.data?.id,
            systemName: res.data?.name,
            serverPcPath: res.data?.pcPath,
            pcPath: pcPath,
        };
        if (res.data?.id) {
            setSysBasePathMap({
                ...sysPasePathMap,
                [sysId || sysCode || '']: recordInfo,
            });
            localStorage.setItem('sysBasePaths', JSON.stringify({
                ...sysPasePathMap,
                [sysId || sysCode || '']: recordInfo,
            }));
        }
        return recordInfo;
    };
    //
    /**
     * 获取跳转的页面地址
     * @param row
     * @param customProps
     * {
     *    baseOnOrigin?: 'backlog' | 'message', //调用来源【backlog(待办事项)， message（消息中心）】
     *    returnJumpResponseAll?: boolean, // 是否返回带有基础路径的路由
     *    oaMode?: boolean, // 启用oa详情模式
     * }
     * @param other  // 其他可传参数
     * @returns
     */
    const getJumpPagePath = async (row, customProps = {}, ...other) => {
        const result = getPathNameByRow(row, {
            returnJumpResponseAll: true,
            ...customProps,
        }, ...other);
        // 跳转的路径
        let redirectPath = '';
        if (typeof result === 'string') {
            redirectPath = result;
        }
        else {
            if (result?.systemId) {
                const systemInfo = await getSystemInfo({ sysId: result?.systemId });
                let pcPath = systemInfo?.pcPath;
                if (!pcPath?.startsWith('/')) {
                    pcPath = '/' + pcPath;
                }
                if (pcPath?.endsWith('/')) {
                    pcPath = pcPath.substring(0, pcPath.length - 1);
                }
                // 基础路径拼接页面路径
                if (result.path) {
                    pcPath = result.path.startsWith('/')
                        ? pcPath + result.path
                        : `${pcPath}/${result.path}`;
                }
                redirectPath = pcPath;
            }
            else if (result?.path) {
                redirectPath = result.path;
            }
        }
        // oa模式配置, oa详情模式（去掉左侧菜单，面包屑层级, 审批流只能展示本单位信息）
        if (customProps.oaMode === true) {
            let joinSuffix = '?';
            if (redirectPath.indexOf('?') > -1) {
                joinSuffix = '&';
            }
            redirectPath =
                redirectPath + joinSuffix + `${oaQuery}&layout=head&breadcrumb=title`;
        }
        return redirectPath;
    };
    return {
        /**
         * 各系统信息的集合， key是系统id，或者是系统code
         */
        sysPasePathMap,
        /**
         * 根据系统id或者系统code获取基本系统信息
         */
        getSystemInfo,
        /**
         * 根据businessCode,businessKey获取跳转页面的路径，带有动态获取基础路径的，不用动态获取路径直接用getPathNameByRow方法
         */
        getJumpPagePath,
    };
};
